import * as React from 'react'
import { ContentLabel } from 'components/ContentLabel'
import styles from './ListHeader.sass'

interface ListHeaderProps {
  children?: React.ReactNode
  count?: number
  clickable?: boolean
  onClick?: () => unknown
  iconRight?: React.ReactNode
  labelRef?: React.LegacyRef<HTMLElement | null>
}

/**
 " List Header
 */
export default function ListHeader({
  children,
  count,
  clickable,
  onClick,
  iconRight,
  labelRef,
}: ListHeaderProps) {
  return (
    <ContentLabel
      clickable={clickable}
      iconRight={iconRight}
      onClick={onClick}
      labelRef={labelRef}
    >
      {children}
      {count !== undefined && <span className={styles.count}> ({count})</span>}
    </ContentLabel>
  )
}
